
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Select from "@/components/form/Select.vue";
import AsnModule from "@/store/modules/asn";
import { SystemModule } from "@/store/modules";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import BarcodeManufacturerModule from "@/store/modules/barcodeSystem/barcodeManufacturer";


import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnFormula } from "@/models/api/asn/formula";

import _ from "lodash";
import { MappableField } from "@/models/api/asn/mappable";

const asnModule = getModule(AsnModule);
const sysModule = getModule(SystemModule);
const bcCompanyModule = getModule(BarcodeCompanyModule);
const bcManufacturerModule = getModule(BarcodeManufacturerModule);

interface ValueOption {
  label: string;
  value: string;
}

@Component({
    components: {
    Select
  }
})
export default class AsnFormulaLine extends Vue {

    @Prop({ default: []})
    Mappable: MappableField[];
    Description: string = "";

    @Prop({ default: null })
    FormulaLine: AsnFormula;

    IsLoadingOptions: boolean = false;

    MapTo: string = "";
    ValueType: string = "";
    Value: string | any = "";
    TextValue: string = "";

    ValueTypeOptions: string[] = [
        // "Commodities",
        // "Manufacturers",
        // "BillTos",
        // "DeliveryFors",
        // "DeliveryTypes",
        // "Companies",
        "Text",
        // "Date"
    ];

    ValueOptions: ValueOption[] = [];


    @Watch("MapTo")
    async selectedMapChanged(newValue){
        if (newValue !== ''){
            await this.onFormulaUpdated();
        }
        this.Description = this.Mappable.filter(x => x.internalName == newValue)[0].description;
    }

    @Watch("ValueType")
    async selectedValueTypeChanged(newValue){
        this.IsLoadingOptions = false;
        this.ValueOptions = [];

        await this.getValueOptions(newValue);

        this.IsLoadingOptions = false;

        await this.onFormulaUpdated();
    }
    
    async getValueOptions(newValue){
        // if(newValue == 'Commodities'){
        //     this.IsLoadingOptions = true;
        //     let commodities = await sysModule.searchCommoditiesByCode({ code: null, billTo: null });
        //     this.ValueOptions = commodities.map(x => ({ label: x.name, value: x.code }));
        // }

        // if (newValue == 'DeliveryFors'){
        //     this.IsLoadingOptions = true;
        //     await sysModule.loadDeliveryFors();
        // }

        // if (newValue == 'DeliveryTypes'){
        //     this.IsLoadingOptions = true;
        //     await sysModule.loadDeliveryTypes();
        //     this.ValueOptions = sysModule.deliveryTypes.map(x => ({ label: x.name, value: x.id }));
        // }

        // if (newValue == 'Companies'){
        //     this.IsLoadingOptions = true;
        //     await bcCompanyModule.loadCompanies();
        //     for(let i = 0; i < bcCompanyModule.companies.length; i++){
        //         this.ValueOptions.push({ label:bcCompanyModule.companies[i].companyName, value: bcCompanyModule.companies[i].id.toString() });
        //     }
        // }

        // if (newValue == 'BillTos'){
        //     this.IsLoadingOptions = true;
        //     await bcCompanyModule.loadBillTos();
        //     for(let i = 0; i < bcCompanyModule.companies.length; i++){
        //         this.ValueOptions.push({ label:bcCompanyModule.billTos[i].billToCompanyId, value: bcCompanyModule.billTos[i].companyId.toString() });
        //     }
        // }

        // if (newValue == 'Manufacturers'){
        //     this.IsLoadingOptions = true;
        //     await bcManufacturerModule.loadManufacturers();
        //     for(let i = 0; i < bcManufacturerModule.manufacturers.length; i++){
        //         this.ValueOptions.push({ label: bcManufacturerModule.manufacturers[i].manufacturerName, value: bcManufacturerModule.manufacturers[i].code });
        //     }
        // }

        // if (newValue == 'Date'){
        //     this.ValueOptions.push({ label: 'Today', value: 'Today' });
        //     this.ValueOptions.push({ label: 'Next Business Day', value: 'Next Business Day' });
        // }
    }

    @Watch("Value")
    selectedValueChanged(newValue){
        if (newValue !== ''){
            this.onFormulaUpdated();
        }
    }

    @Watch("TextValue")
    selectedTextValueChanged(newValue){
        if (newValue !== ''){
            this.onFormulaUpdated();
        }
    }

    @Watch("KVP")
    selectedKVPChanged(newValue){
        if (newValue !== ''){
            this.onFormulaUpdated();
        }
    }

    async onRemoveFormula(){
        this.$emit('formula-removed', this.FormulaLine);
    }

    async onFormulaUpdated(){
        this.$emit('formula-updated', 
        {   
            id: this.FormulaLine.id, 
            map: this.MapTo, 
            valueType: this.ValueType, 
            value: this.Value,
            textValue: this.TextValue,
        });
    }
    
    async created(){
        this.MapTo = this.FormulaLine.map;
        this.ValueType = this.FormulaLine.valueType;
        this.Value = this.FormulaLine.value;
        this.TextValue = this.FormulaLine.textValue;
    }
}

